import React from 'react';
import { Modal } from 'react-bootstrap';
import styles from './CampaignErrorModal.module.scss';
import Announcement from '../../../assets/annoucement.gif';

const ErrorModal = ({
  show,
  onHide,
  errorMessage,
  errorLink,
  title = 'Upgrade',
  showResolveButton = true,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
      style={{ zIndex: 2000 }}
    >
      <Modal.Header closeButton>
        <Modal.Title className={styles.title}>
          {showResolveButton ? title : 'Limit Reached'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={styles.wraper}>
          <div className={styles.wraper__lotie}>
            <img src={Announcement} alt="annoucement" />
          </div>
          <div className={styles.wraper__heading}>
            {showResolveButton ? 'Upgrade your plan' : 'Limit Reached'}
          </div>
          <div className={styles.wraper__description}>{errorMessage}</div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="cancel_btn" variant="secondary" onClick={onHide}>
          Cancel
        </button>
        {errorLink && showResolveButton && (
          <button
            className="secondary_btn"
            variant="primary"
            onClick={() => window.open(errorLink, '_blank')}
          >
            Resolve
          </button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ErrorModal;
